"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Container = _interopRequireDefault(require("@material-ui/core/Container"));
var _useSystemLinks = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useSystemLinks"));
var _ReactHTML = _interopRequireDefault(require("@micado-digital/react-html/ReactHTML"));
var _ShopContext = _interopRequireDefault(require("../../context/ShopContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Payment01 = () => {
  const {
    id: paymentID,
    type: paymentType
  } = (0, _reactRouterDom.useParams)();
  const {
    shopData
  } = (0, _react.useContext)(_ShopContext.default);
  const {
    paymentMethods = []
  } = shopData;
  const [id, setID] = (0, _react.useState)();
  const [type, setType] = (0, _react.useState)();
  const systemLink = (0, _useSystemLinks.default)();
  const confirmationUrl = systemLink("shop-payment-success");
  const location = window.location.href;
  (0, _react.useEffect)(() => {
    var _segments$length;
    const segments = location.split("/");
    const segmentsLength = (_segments$length = segments === null || segments === void 0 ? void 0 : segments.length) !== null && _segments$length !== void 0 ? _segments$length : 0;
    setID(encodeAndReplaceID(paymentID !== null && paymentID !== void 0 ? paymentID : segments === null || segments === void 0 ? void 0 : segments[segmentsLength - 1]));
    setType(paymentType !== null && paymentType !== void 0 ? paymentType : segments === null || segments === void 0 ? void 0 : segments[segmentsLength - 2]);
  }, [location, paymentID, paymentType]);
  const encodeAndReplaceID = id => {
    if (!id) return;
    return encodeURI(id.replace("-", "."));
  };
  if (confirmationUrl && id && type === "hobex") {
    var _paymentMethods$find;
    const options = paymentMethods === null || paymentMethods === void 0 || (_paymentMethods$find = paymentMethods.find(_ref => {
      let {
        identifier
      } = _ref;
      return identifier === "hobex";
    })) === null || _paymentMethods$find === void 0 ? void 0 : _paymentMethods$find.options;
    return /*#__PURE__*/_react.default.createElement(_Container.default, {
      className: "mco-shop-payment",
      maxWidth: "lg"
    }, /*#__PURE__*/_react.default.createElement(_ReactHTML.default, {
      html: "<script src=\"https://oppwa.com/v1/paymentWidgets.js?checkoutId=".concat(id, "\"></script><form action=\"").concat(confirmationUrl !== null && confirmationUrl !== void 0 ? confirmationUrl : "/", "\" class=\"paymentWidgets\" data-brands=\"").concat(options, "\"></form>")
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
Payment01.propTypes = {};
var _default = exports.default = Payment01;